import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-drop-down-single-select',
  templateUrl: './drop-down-single-select.component.html',
  styleUrls: ['./drop-down-single-select.component.css'],
})
export class DropDownSingleSelectComponent {
  @Input() selectedOption: string = '';
  @Input() DropDownOptions: any = [];
  @Input() name: string = '';
  @Output() typeSelectedChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetAllVal: EventEmitter<any> = new EventEmitter<any>();

  setSelected(option: string) {
    this.selectedOption = option;
    console.log(this.selectedOption);

    this.typeSelectedChanged.emit({
      selectedOption: this.selectedOption,
      name: this.name,
      type: 'onChange',
    });
  }

  resetVal() {
    this.resetAllVal.emit({
      name: this.name,
      type: 'reset',
    });
  }

  clearInput() {
    this.setSelected('');
    this.resetVal();
  }
}
